import React from 'react';

export const LanguageIcon = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
			<g clipPath="url(#clip0_15531_113771)">
				<path
					d="M7.99998 14.6667C11.6819 14.6667 14.6666 11.6819 14.6666 8.00001C14.6666 4.31811 11.6819 1.33334 7.99998 1.33334C4.31808 1.33334 1.33331 4.31811 1.33331 8.00001C1.33331 11.6819 4.31808 14.6667 7.99998 14.6667Z"
					stroke="#CCCCCC"
					strokeWidth="1.5"
					strokeLinecap="square"
				/>
				<path
					d="M7.36305 14.0186C7.70269 14.4064 8.29727 14.4064 8.63691 14.0186C9.99007 12.4737 10.6666 10.4675 10.6666 8.00001C10.6666 5.5325 9.99007 3.5263 8.63691 1.9814C8.29727 1.59364 7.70269 1.59364 7.36305 1.9814C6.00989 3.5263 5.33331 5.5325 5.33331 8.00001C5.33331 10.4675 6.00989 12.4737 7.36305 14.0186Z"
					stroke="#CCCCCC"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
				<path
					d="M1.66669 6H14.3334M1.66669 10H14.3334"
					stroke="#CCCCCC"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_15531_113771">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
